import * as actionTypes from './actionTypes';
import { Auth } from 'aws-amplify';
import { Credentials } from '@aws-amplify/core';
import { clearMfaPending, setMfaPending, getMfaPending } from '../mfaLoginContext';
// import { API } from 'aws-amplify';

const isMfaCodeChallenge = (challengeName) =>
    challengeName === 'SMS_MFA' || challengeName === 'SOFTWARE_TOKEN_MFA';

const hasSignInSession = (cognitoUser) => {
    const session =
        cognitoUser &&
        (typeof cognitoUser.getSignInUserSession === 'function'
            ? cognitoUser.getSignInUserSession()
            : cognitoUser.signInUserSession);
    return Boolean(session && session.idToken);
};

const disableSoftwareMfaThenLogin = (dispatch, cognitoUser, responseData) => {
    return Auth.setPreferredMFA(cognitoUser, 'NOMFA')
        .catch(() => {})
        .then(() => finishWebLoginFromUser(dispatch, cognitoUser, responseData));
};

export const authMfaRequired = (challengeName) => ({
    type: actionTypes.AUTH_MFA_REQUIRED,
    challengeName
});

export const authMfaSubmitFail = (error) => ({
    type: actionTypes.AUTH_MFA_SUBMIT_FAIL,
    error
});

export const authMfaSetupReady = (secret, enrollUsername) => ({
    type: actionTypes.AUTH_MFA_SETUP_READY,
    secret,
    enrollUsername
});

export const authStart = () => {
    return {
        type: actionTypes.AUTH_START
    };
};

export const authStartChecking = () => {
    return {
        type: actionTypes.AUTH_START_CHECKING
    };
};

export const checkFail = () => {
    return {
        type: actionTypes.AUTH_CHECK_FAIL
    };
};

export const authSuccess = (token, user,userFullname) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        token: token,
        user: user,
        userFullname: userFullname,      
    };
};

export const authFail = (error) => {
    return {
        type: actionTypes.AUTH_FAIL,
        error: error
    };
};

export const logout = () => {
    clearMfaPending();
    Auth.signOut();
    localStorage.removeItem('user');
    return {
        type: actionTypes.AUTH_LOGOUT
    };
};

export const authCancelMfa = () => {
    return dispatch => {
        clearMfaPending();
        Auth.signOut({ global: false }).catch(() => {});
        dispatch({ type: actionTypes.AUTH_MFA_CANCEL });
    };
};

/** Skip optional authenticator setup and finish login with the existing Cognito session. */
export const authSkipOptionalMfa = () => {
    return dispatch => {
        const { user, gate } = getMfaPending();
        if (!user || !gate || !gate.optional) {
            dispatch(authFail('Sign-in session expired. Please try again.'));
            return;
        }
        dispatch(authStart());
        disableSoftwareMfaThenLogin(dispatch, user, gate.responseData);
    };
};

export const authCompleteMfa = (code) => {
    return dispatch => {
        const { user, gate } = getMfaPending();
        if (!user || !gate) {
            dispatch(authFail('Sign-in session expired. Please try again.'));
            return;
        }
        dispatch(authStart());
        Auth.confirmSignIn(user, code, user.challengeName)
            .then(response => {
                clearMfaPending();
                const responseData = gate.responseData;
                const session =
                    typeof response.getSignInUserSession === 'function'
                        ? response.getSignInUserSession()
                        : response.signInUserSession;
                if (!session || !session.idToken) {
                    dispatch(authFail('Sign-in could not be completed.'));
                    return;
                }
                const isAdmin = responseData && responseData.isAdmin === 1 ? 'true' : 'false';
                localStorage.setItem('user', response.username);
                dispatch(authSuccess(
                    true,
                    {
                        username: response.username,
                        name: session.idToken.payload.name,
                        contractor: responseData && responseData.contractor,
                        administrator: isAdmin
                    },
                    session.idToken.payload.name
                ));
            })
            .catch(error => {
                dispatch(authMfaSubmitFail(error.message || 'Invalid code'));
            });
    };
};

const finishWebLoginFromUser = (dispatch, cognitoUser, responseData) => {
    clearMfaPending();
    const session =
        typeof cognitoUser.getSignInUserSession === 'function'
            ? cognitoUser.getSignInUserSession()
            : cognitoUser.signInUserSession;
    if (!session || !session.idToken) {
        dispatch(authFail('Sign-in could not be completed. Please try again.'));
        return;
    }
    const username =
        typeof cognitoUser.getUsername === 'function'
            ? cognitoUser.getUsername()
            : cognitoUser.username;
    const isAdmin = responseData && responseData.isAdmin === 1 ? 'true' : 'false';
    localStorage.setItem('user', username);
    dispatch(authSuccess(
        true,
        {
            username,
            name: session.idToken.payload.name,
            contractor: responseData && responseData.contractor,
            administrator: isAdmin
        },
        session.idToken.payload.name
    ));
};

export const authCompleteTotpEnrollment = (code) => {
    return dispatch => {
        const { user, gate } = getMfaPending();
        if (!user || !gate) {
            dispatch(authFail('Sign-in session expired. Please try again.'));
            return;
        }
        dispatch(authStart());
        Auth.verifyTotpToken(user, code)
            .then(() => Auth.setPreferredMFA(user, 'TOTP').catch(() => {}))
            .then(() => {
                const session =
                    typeof user.getSignInUserSession === 'function'
                        ? user.getSignInUserSession()
                        : user.signInUserSession;
                if (!session || (typeof session.isValid === 'function' && !session.isValid())) {
                    throw new Error('Could not complete sign-in.');
                }
                return Credentials.clear().then(() => Credentials.set(session, 'session'));
            })
            .then(() => {
                finishWebLoginFromUser(dispatch, user, gate.responseData);
            })
            .catch(error => {
                dispatch(authMfaSubmitFail(error.message || 'Invalid code'));
            });
    };
};

let headerglobal = {
    'x-api-key': process.env.REACT_APP_CITY_API_TOKEN,        
    'Accept': 'application/json',
    'Content-Type': 'application/json'
}

export const auth = (email, password) => {
    return dispatch => {
        clearMfaPending();
        dispatch(authStart());    
        const authData = {
            email: email,
            password: password,
            returnSecureToken: true
        };
            
            let API_USER_ACCESS = process.env.REACT_APP_GLOBAL_API + '/user_app_access_get?id=' + email;
        
            fetch(API_USER_ACCESS, {
                method: 'GET',
                headers: headerglobal,
                })
                .then((response) => {
                if (!response.ok) throw Error(response.statusText);
                return response.json();
                })
                .then((responseJson) => {
                let responseData = responseJson[process.env.REACT_APP_GLOB_APP_ENV]

                const web = responseData.app_access.includes("web")
                const contractor = responseData.contractor
                let admin = responseData.isAdmin
                if (admin===1) {
                    admin = "true"
                }
                else {
                    admin = "false"
                }
                localStorage.setItem("web", web)
                localStorage.setItem("contractor", contractor)
                localStorage.setItem("admin", admin)

                if(responseData["accountStatus"] === "true"){
                    let isAdmin 
                    if(responseData["isAdmin"] === 1){
                        isAdmin = "true"
                    } else{
                        isAdmin = "false"
                    }
                    if (responseData["app_access"].includes("web")){
    
                        Auth.signIn(authData.email, authData.password)
                        .then(response => {
                            const challenge = response.challengeName;

                            if (challenge && isMfaCodeChallenge(challenge)) {
                                setMfaPending(response, { responseData });
                                dispatch(authMfaRequired(challenge));
                                return;
                            }

                            if (challenge === 'MFA_SETUP') {
                                // OPTIONAL pools can send MFA_SETUP after a skipped/disabled
                                // authenticator. If the password session already exists, skip
                                // enrollment instead of blocking login.
                                if (hasSignInSession(response)) {
                                    disableSoftwareMfaThenLogin(dispatch, response, responseData);
                                    return;
                                }
                                const enrollName = response.username || authData.email;
                                setMfaPending(response, {
                                    responseData,
                                    enrollUsername: enrollName,
                                    optional: true
                                });
                                dispatch(authMfaRequired('MFA_SETUP_OPTIONAL'));
                                Auth.setupTOTP(response)
                                    .then(secret => {
                                        dispatch(authMfaSetupReady(secret, enrollName));
                                    })
                                    .catch(err => {
                                        console.log('Authenticator setup could not start:', err);
                                        disableSoftwareMfaThenLogin(dispatch, response, responseData);
                                    });
                                return;
                            }

                            if (challenge === 'SELECT_MFA_TYPE') {
                                dispatch(authFail('Choose a verification method in the AWS console first, or contact an administrator.'));
                                Auth.signOut({ global: false }).catch(() => {});
                                return;
                            }

                            if (challenge === 'NEW_PASSWORD_REQUIRED') {
                                dispatch(authFail('A new password is required. Complete that step in Cognito before using this login.'));
                                Auth.signOut({ global: false }).catch(() => {});
                                return;
                            }

                            if (challenge) {
                                dispatch(authFail('This sign-in step is not supported in the web app.'));
                                Auth.signOut({ global: false }).catch(() => {});
                                return;
                            }

                            if (!hasSignInSession(response)) {
                                dispatch(authFail('Sign-in could not be completed.'));
                                return;
                            }

                            // OPTIONAL pool with no MFA challenge: sign in. Do not call
                            // setupTOTP here — associating a token and skipping it makes
                            // Cognito reject the next password with "Incorrect username or password".
                            finishWebLoginFromUser(dispatch, response, responseData);
                        })
                        .catch(error => {
                            dispatch(authFail(error.message));
                        });
                    } else{
                        dispatch(authFail("Permission denied"));
                    }
                } else{
                    dispatch(authFail("User is disabled"));
                }
    
                }).catch((error) => {
                    console.log('request failed loading the api' + error);
                    dispatch(authFail("Permission denied"));

                });   
    };
};

export const setAuthRedirectPath = (path) => {
    return {
        type: actionTypes.SET_AUTH_REDIRECT_PATH,
        path: path
    };
};

export const authCheckState = () => {
    return dispatch => {
        dispatch(authStartChecking());
        Auth.currentSession()
            .then(response => {
                if (!response || !response.idToken) {
                    dispatch(checkFail());
                    dispatch(logout());
                    return;
                }
                localStorage.setItem('user', response.idToken.payload["cognito:username"]);
                // check access
                if (localStorage.getItem('web') ==="true"){
                    dispatch(authSuccess(
                        true,
                        {'username': localStorage.getItem('user'), 
                        'name': response.idToken.payload.name, 
                        'contractor': localStorage.getItem('contractor'),
                        'administrator': localStorage.getItem('admin')},
                        response.idToken.payload.name
                        ));
                }else{
                    dispatch(checkFail());
                    dispatch(logout());
                }
            })
            .catch(err =>{ 
                console.log("Auth: " + err)
                dispatch(checkFail());
                dispatch(logout());
                
            });

        // }
    };
};
